import { Editor } from "slate";
const removeMarks = (editor, marks) => {
  Editor.withoutNormalizing(editor, () => {
    for (const mark in marks) {
      Editor.removeMark(editor, mark);
    }
  });
};
export {
  removeMarks
};
//# sourceMappingURL=removeMarks.js.map
